import _ = require("underscore");
import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");

function show_popup(url: string, popup = true) {
    window.open(url, popup ? "_blank" : "_self", "resizable=1");
}

/* 
admittedly convoluted!  
popup-tool command 
  creates InfoViewer controller 
    containing google-it command 
      handled by goto-handler
*/
class Command extends Base<{
    out: {
        controller: {
            args: {
                out: {
                    layers: Array<Rhythm.GIS.FeatureQueryResultLayer>;
                }
            }
        }
    }
}> {

    static about = `
admittedly convoluted!  
popup-tool command 
  creates InfoViewer controller 
    containing google-it command 
      handled by goto-handler
      `;

    static options = {
        "popup": {
            "about": "_true_ to open as a popup dialog"
        },
        "url-template": {
            "about": "identify the markup template"
        },
    }

    static output = {
        "url": {
            "about": "The URL to goto",
        },
    }

    // opens a url in a popup window
    execute(args = this.args) {
        let options = this.options;

        Utils.ifOption(options, "url-template", urlTemplate => {
            let controller = args.out.controller; // controls/view adds itself as the execute arg for commands (TODO: every controller should do this)
            let layers = controller.args.out.layers; // selection tools should put features within a layers container (TODO: need to formalize this via interfaces)
            let feature = layers[0].features[0];
            let template = _.template(urlTemplate);
            let templateArgs = _.defaults({}, feature.attributes, feature);
            try {
                let url = template(templateArgs);

                show_popup(url, (options["popup"] === "true"));

                this.trigger({
                    url: url
                });
            } catch (ex) {
                console.error("invalid url template:", urlTemplate, ex);
            }

        });

    }

}

export = Command;  